import React from 'react';
import { useDictionaryLegalForms } from '../../../dict-legal-form/dict-legal-forms-api';
import { FormAutocomplete, FormTextField } from '@eas/common-web';
import { dictionaryLabelMapper } from '../../../../components/form/mappers/label-mappers';
import { icoMaxLength } from '../subjects-utils';
import { HelpLabel } from '../../../../components/help/help-label';

export function LegalEntityBasicFields({
  prefix,
  codePrefix = 'SUBJECT',
  disabled,
  disabledIco,
}: {
  prefix?: string;
  codePrefix?: string;
  disabled?: boolean;
  disabledIco?: boolean;
}) {
  const legalForms = useDictionaryLegalForms();

  const names = {
    legalForm: prefix ? `${prefix}.legalForm` : 'legalForm',
    ico: prefix ? `${prefix}.ico` : 'ico',
    name: prefix ? `${prefix}.name` : 'name',
  };

  return (
    <>
      <FormAutocomplete
        name={names.legalForm}
        source={legalForms}
        labelMapper={dictionaryLabelMapper}
        tooltipMapper={dictionaryLabelMapper}
        label={
          <HelpLabel label="Právní forma" code={`${codePrefix}_LEGAL_FORM`} />
        }
        disabled={disabled}
      />
      <FormTextField
        name={names.ico}
        label={<HelpLabel label="IČO" code={`${codePrefix}_ICO`} required />} // Povinné pole
        disabled={disabledIco ? disabledIco : disabled}
        inputProps={{ maxLength: icoMaxLength }}
        onChangeEvent={(e) => {
          e.target.value = e.target.value.replace(/[^0-9]/gi, '');
        }}
      />
      <FormTextField
        name={names.name}
        label={<HelpLabel label="Název" code={`${codePrefix}_NAME`} required />} // Povinné pole
        disabled={disabled}
      />
    </>
  );
}
